const region = [
	"서울",
	"경기",
	"인천",
	"강원",
	"충남",
	"대전",
	"충북",
	"세종",
	"부산",
	"울산",
	"대구",
	"경북",
	"경남",
	"전남",
	"광주",
	"전북",
	"제주",
];

export { region };
